import { testCurrentDomain } from 'ui-utils';

const chcDomains = [
  'chc',
  'changehealthcare',
  // 'localhost:3000', // uncomment this to test locally
];

const nextgenDomains = [
  'nextgen',
  // 'localhost:3000', // uncomment this to test locally
];

const greenwayDomains = [
  'greenway',
  // 'localhost:3000', // uncomment this to test locally
];

export const isCHC = testCurrentDomain(chcDomains);
export const isNextGen = testCurrentDomain(nextgenDomains);
export const isGreenway = testCurrentDomain(greenwayDomains);

const lumaPartnersDomains = [...chcDomains, ...nextgenDomains, ...greenwayDomains];

export const isLumaPartner = testCurrentDomain(lumaPartnersDomains);

export const currentDomainOwner = () => {
  if (isCHC) {
    return 'chc';
  }
  if (isNextGen) {
    return 'nextgen';
  }
  if (isGreenway) {
    return 'greenway';
  }
  return 'luma';
};
